import { Fade, Menu, useTheme } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * The menu of the picker box: it opens below `boxEl`, the picker box, and
 * is exactly as wide as it. Its paper, its gap from the box and its rows
 * look as every menu of the app does, from the theme.
 */
export function PickerMenu({
    open,
    boxEl,
    onClose,
    children,
    'data-testid': testId,
}: {
    open: boolean;
    boxEl: HTMLElement | null;
    onClose: () => void;
    children: ReactNode;
    'data-testid'?: string;
}) {
    const theme = useTheme();
    return (
        <Menu
            anchorEl={boxEl}
            open={open && boxEl !== null}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            TransitionComponent={Fade}
            transitionDuration={theme.transitions.duration.short}
            data-testid={testId}
            slotProps={{
                paper: {
                    sx: {
                        width: boxEl?.offsetWidth,
                        maxWidth: 'none',
                    },
                },
            }}
        >
            {children}
        </Menu>
    );
}
